import {selectTheme} from '../../store'
import {useTranslation} from '../../lib'
import {Select, Tooltip} from '..'
import {AccelerometerIcon} from '../../asset/image'

export const SmartphoneSpecPanel = (props) => {
  const {color, pad, fontWeight, fontSize} = selectTheme()
  const {t} = useTranslation()

  return (
    <div
      css={{
        width: '100%',
        borderRadius: '5px',
        padding: pad.xl,
        background: color.white,
      }}>
      <p
        css={{
          fontWeight: fontWeight.bold,
          marginBottom: pad.large,
        }}>
        Setup Data Type and Sampling Rate
      </p>
      <div
        css={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          marginBottom: pad.small,
        }}>
        <p
          css={{
            color: color.grey_400,
          }}>
          Data Type
        </p>
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
          }}>
          <p
            css={{
              color: color.grey_400,
              marginRight: pad.small,
            }}>
            Sampling Rate
          </p>
          <Tooltip />
        </div>
      </div>
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: `${pad.medium} ${pad.large}`,
          border: `1px solid ${color.grey_160}`,
          borderRadius: '5px',
        }}>
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
          }}>
          <img
            src={AccelerometerIcon}
            width='40'
            css={{
              marginRight: pad.large,
            }}
          />
          <div>
            <p
              css={{
                fontWeight: fontWeight.bold,
                marginBottom: pad.xs,
              }}>
              Accelerometer
            </p>
            <p>Acceleration summary, also known as 3-axis zero crossings + energy levels.</p>
          </div>
        </div>
        <Select css={{width: '110px'}} value={{value: 10, label: '10 Hz'}} />
      </div>
    </div>
  )
}
